angular.module('bmsApp.merrymaids.job')
	.factory('MMJobPartSvc', function ($rootScope,
									   $q,
									   $modal,
									   notify,
									   CRUDSvc) {

		function transformJobPart(jobPart) {
			if (angular.isObject(jobPart)) {
				if (angular.isString(jobPart.start_time)) {
					jobPart.start_time = jobPart.start_time ? moment(jobPart.start_time, 'HH:mm:ss') : null;
				}
				if (angular.isString(jobPart.end_time)) {
					jobPart.end_time = jobPart.end_time ? moment(jobPart.end_time, 'HH:mm:ss') : null;
				}
			}
			return jobPart;
		}

		function showSaveCleanModal(jobId, dateOrJobPartEvent) {
			console.info('HIT');
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/merrymaids/job/templates/MMSaveCleanModal.html',
				controller: 'MMSaveCleanModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					jobId: function () {
						return jobId;
					},
					dateOrJobPartEvent: function () {
						return angular.copy(dateOrJobPartEvent);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					notify({
						message: 'Clean created/updated successfully'
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});

			return modalInstance.result;
		}

		function showMoveCleanModal(jobPartEvent) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/merrymaids/job/templates/MMMoveCleanModal.html',
				controller: 'MMMoveCleanModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					jobPartEvent: function () {
						return angular.copy(jobPartEvent);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					notify({
						message: 'Clean moved successfully'
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});

			return modalInstance.result;
		}

		function index(params)
		{
			return CRUDSvc.get('api/merrymaids/job-part/index', params);
		}

		function save(jobPart) {
			return CRUDSvc.post('api/merrymaids/job-part/save', jobPart);
		}

		function read(jobPartId, params) {
			return CRUDSvc.get('api/merrymaids/job-part/read/' + jobPartId, params);
		}

		function moveClean(jobCleanEvent) {
			return CRUDSvc.post('api/merrymaids/job-part/move', jobCleanEvent);
		}

		function bulkInactive(params) {
			return CRUDSvc.post('api/merrymaids/job-part/bulk-inactive', params);
		}



		function close(jobPart) {
			var copy = angular.copy(jobPart);
			if (moment.isMoment(copy.start_time)) {
				copy.start_time = copy.start_time.format('HH:mm:ss');
			}
			if (moment.isMoment(copy.end_time)) {
				copy.end_time = copy.end_time.format('HH:mm:ss');
			}
			return CRUDSvc.post('api/merrymaids/job-part/close', copy);
		}

		function preinvoice(id) {
			return CRUDSvc.post('api/merrymaids/job-part/preinvoice/' + id);
		}

		function calculateRouteEmployeeMileage(jobPartId, employeeId, miles) {
			return CRUDSvc.post('api/merrymaids/job-part/calculate-employee-mileage', {
				jobPartId: jobPartId,
				employeeId: employeeId,
				miles: miles
			});
		}

		var self = {
			calendarEvents: function (params) {
				return CRUDSvc.get('api/merrymaids/job-part/calendarEvents', params);
			},
			customerInvoiceOptions: function (customerId) {
				return CRUDSvc.get('api/merrymaids/job-part/customer-invoice-options/' + customerId);
			},
			employeeWorkHistory: function (employeeId, params) {
				return CRUDSvc.get('api/merrymaids/employee-work-history/' + employeeId, params);
			},
			transformJobPart: transformJobPart,
			showMoveCleanModal: showMoveCleanModal,
			showSaveCleanModal: showSaveCleanModal,
			index: index,
			save: save,
			read: read,
			moveClean: moveClean,
			bulkInactive: bulkInactive,
			close: close,
			preinvoice: preinvoice,
			calculateRouteEmployeeMileage: calculateRouteEmployeeMileage
		};
		return self;

	});
